import { Component, OnInit, ChangeDetectionStrategy, Input } from '@angular/core';
import { Router } from '@angular/router';
import { showErrorSwal } from 'libs/utils/src/lib/validation-helpers/show-error-swal';
import { BehaviorSubject, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { LinkInformation } from '../../interfaces/linkinformation.interface';
import { LinkService } from '../../services/link.service';
import { LinkEditPricingComponent } from '../../link/link-edit-pricing/link-edit-pricing.component';
import { LinkEditInformationComponent } from '../../link/link-edit-information/link-edit-information.component';
import { DxCheckBoxModule } from 'devextreme-angular';
import { NgIf, NgStyle, AsyncPipe } from '@angular/common';
import { ALTabsComponent } from '@asamco/application-link/shared';

@Component({
    selector: 'app-shell-tile-information',
    templateUrl: './tile-information.component.html',
    styleUrls: ['./tile-information.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [NgIf, ALTabsComponent, LinkEditInformationComponent, LinkEditPricingComponent, DxCheckBoxModule, NgStyle, AsyncPipe]
})
export class TileInformationComponent implements OnInit {

  @Input()
  linkInformation: LinkInformation

  public userAccepted: boolean = false;

  title: string = "Integration information"
  public showSubject = new BehaviorSubject<boolean>(false);

  /** Currently selected tab */
  public selectedTab$ = new BehaviorSubject<number>(1);

  /** Array containing the tabs */
  public tabInfo = [
    {
      id: 1,
      text: 'Information',
      icon: 'far fa-info-circle',
    },
    {
      id: 2,
      text: 'Pricing',
      icon: 'far fa-wallet',
    }
  ];

  constructor(private linkService: LinkService, private router: Router) { }

  ngOnInit(): void {
    this.userAccepted = false;
  }

  showModal() {
    this.showSubject.next(true);
    this.ngOnInit();
  }

  /** Adds new application by navigating to the link edit page */
  public addApplication() {
    this.linkService
      .createLink(this.linkInformation.id)
      .pipe(
        catchError(err => {
          showErrorSwal(err);
          return of(0);
        })
      )
      .subscribe({
        next: result => {
          if (result > 0) {
            this.router.navigate(['application-link/dashboard']);
          }
        },
        error: error => {
          showErrorSwal(error)
        }});

  }

  cancel() {
    this.showSubject.next(false)
  }

}
